// export const BASE_URL = "http://192.168.0.2:8000";
// export const IMAGE_URL = BASE_URL;


export const BASE_URL = "https://admin.denny.digitalcampaign.co.za";
export const IMAGE_URL = BASE_URL + "/public";
export const FRONTEND_URL = "https://denny.digitalcampaign.co.za";
